import React from 'react';
import './Test.css'; // Import the CSS file

const Test = () => {
    return (
        <div className="publication-container">
            <h1>My Publications</h1>
            <ul className="publication-list">
                <li>
                    <strong>
                        <a href="https://scholar.google.com/citations?user=nP85SgUAAAAJ&hl=en" className="publication-link" target="_blank" rel="noopener noreferrer">
                            Ahmed, I., Ahmed, G., <span style={{ color: "#c770f0" }}>Sanjid, K. S.</span>, Hossain, M. T., Khan, M. N., Khan, M. M., Rahman, M. A., Haque, S. A., Rupa, S. A., Mia, M. M., Kamal, M. H. M., Sarker, M. M. K., & Uddin, M. M.
                        </a>
                    </strong> 
                    <br />
                    OncoVision: Integrating Mammography and Clinical Data through Attention-Driven Multimodal AI for Enhanced Breast Cancer Diagnosis. 
                    <span className="journal-name"> <strong>Nature Biomedical Engineering</strong> (under review)</span>
                </li>
                <li>
                    <strong>
                        <a href="https://scholar.google.com/citations?user=nP85SgUAAAAJ&hl=en" className="publication-link" target="_blank" rel="noopener noreferrer">
                            Ahmed, I., Hossain, M. T., Nahid, M. Z. I., <span style={{ color: "#c770f0" }}>Sanjid, K. S.</span>, Junayed, M. S. S., Uddin, M. M., & Khan, M. M.
                        </a>
                    </strong> 
                    <br />
                    Pioneering precision in lumbar spine MRI segmentation with advanced deep learning and data enhancement. 
                    <span className="journal-name"> <strong>Machine Learning with Applications</strong></span>
                </li>
                <li>
                    <strong>
                        <a href="https://scholar.google.com/citations?user=nP85SgUAAAAJ&hl=en" className="publication-link" target="_blank" rel="noopener noreferrer">
                            Junayed, M. S. S., <span style={{ color: "#c770f0" }}>Sanjid, K. S.</span>, Hossain, M. T., Uddin, M. M., & Haque, S. A.
                        </a>
                    </strong> 
                    <br />
                    Topology-aware anatomical segmentation of the Circle of Willis: HUNet unveils the vascular network. 
                    <span className="journal-name"> <strong>IET Image Processing</strong></span>
                </li>
                <li>
                    <strong>
                        <a href="https://doi.org/10.1016/j.iswa.2024.200382" className="publication-link" target="_blank" rel="noopener noreferrer">
                            <span style={{ color: "#c770f0" }}>Sanjid, K. S.</span>, Junayed, M. S. S., Hossain, M. T., Wang, T. L., Uddin, M. M., & Haque, S. A.
                        </a>
                    </strong> 
                    <br />
                    From pixels to pathology: A novel dual-pathway multi-scale hierarchical upsampling network for MRI-based prostate zonal segmentation. 
                    <span className="journal-name"> <strong>Intelligent Systems with Applications</strong></span>
                </li>
                <li>
                    <strong>
                        <a href="https://scholar.google.com/citations?user=nP85SgUAAAAJ&hl=en" className="publication-link" target="_blank" rel="noopener noreferrer">
                            <span style={{ color: "#c770f0" }}>Sanjid, K. S.</span>, Hossain, M. T., Junayed, M. S. S., Uddin, M. M., & Wang, Y.-L., Uddin, N. M.
                        </a>
                    </strong> 
                    <br />
                    Integrating Mamba Sequence Model and Hierarchical Upsampling Network for Accurate Semantic Segmentation of Multiple Sclerosis Lesion. 
                    <span className="journal-name"> <strong>LSMS 2024, ICSEE 2024 conference, Communications in Computer and Information Science, vol. 2216</strong></span>
                </li>
                <li>
                    <strong>
                        <a href="https://scholar.google.com/citations?user=nP85SgUAAAAJ&hl=en" className="publication-link" target="_blank" rel="noopener noreferrer">
                            Hossain, M. T., Junayed, M. S. S., <span style={{ color: "#c770f0" }}>Sanjid, K. S.</span>, Rohan, A. H., Khan, M. A., Haque, S. A., & Uddin, M. M.
                        </a>
                    </strong> 
                    <br />
                    Multi-scale learning network for multiple sclerosis lesion segmentation from longitudinal brain MRI. 
                    <span className="journal-name"> <strong>2023 26th International Conference on Computer and Information Technology (ICCIT)</strong></span>
                </li>
                <li>
                    <strong>
                        <a href="https://scholar.google.com/citations?user=nP85SgUAAAAJ&hl=en" className="publication-link" target="_blank" rel="noopener noreferrer">
                            <span style={{ color: "#c770f0" }}>Sanjid, K. S.</span>, Hossain, M. T., Junayed, M. S. S., & Uddin, M. M.
                        </a>
                    </strong> 
                    <br />
                    Optimizing Universal Lesion Segmentation: State Space Model-Guided Hierarchical Networks with Feature Importance Adjustment. 
                    <span className="journal-name"> <strong>IEEE Transactions on Artificial Intelligence</strong> (under review)</span>
                </li>
            </ul>
        </div>
    );
};

export default Test;
